export default __webpack_public_path__ + "static/media/book_int_whoosh.8a919456.mp3";